// Product page functionality

document.addEventListener('DOMContentLoaded', function() {
  // Product image gallery
  const mainImage = document.getElementById('product-main-image');
  const thumbnails = document.querySelectorAll('.product-gallery__thumbnail');

  thumbnails.forEach(thumbnail => {
    thumbnail.addEventListener('click', function() {
      // Update main image
      const newImageUrl = this.dataset.imageUrl;
      if (mainImage && newImageUrl) {
        mainImage.src = newImageUrl;
      }

      // Update active state
      thumbnails.forEach(t => t.classList.remove('active'));
      this.classList.add('active');
    });
  });

  // Quantity selector
  const quantityInput = document.getElementById('quantity');
  const decreaseBtn = document.querySelector('[data-quantity-decrease]');
  const increaseBtn = document.querySelector('[data-quantity-increase]');

  if (decreaseBtn && quantityInput) {
    decreaseBtn.addEventListener('click', function() {
      const currentValue = parseInt(quantityInput.value) || 1;
      if (currentValue > 1) {
        quantityInput.value = currentValue - 1;
      }
    });
  }

  if (increaseBtn && quantityInput) {
    increaseBtn.addEventListener('click', function() {
      const currentValue = parseInt(quantityInput.value) || 1;
      quantityInput.value = currentValue + 1;
    });
  }

  // Variant selection - update price display and serving info
  const variantInputs = document.querySelectorAll('.variant-button input[type="radio"]');
  const priceDisplay = document.querySelector('.product-template__price--regular');
  const servingInfoContainer = document.getElementById('serving-info');

  // Use global serving size map (injected by product template)
  const servingSizes = window.SERVING_SIZES || {};

  function getServingSize(variantTitle) {
    const normalizedTitle = variantTitle.toLowerCase().trim();
    // Check larger numbers first to avoid false matches (e.g., 160 before 60)
    const sortedKeys = Object.keys(servingSizes).sort((a, b) => {
      const aNum = parseInt(a) || 0;
      const bNum = parseInt(b) || 0;
      return bNum - aNum;
    });

    for (const key of sortedKeys) {
      if (normalizedTitle.includes(key)) {
        return servingSizes[key];
      }
    }
    return '';
  }

  variantInputs.forEach(input => {
    input.addEventListener('change', function() {
      if (this.checked) {
        // Update price
        const priceText = this.parentElement.querySelector('.variant-button__price');
        if (priceText && priceDisplay) {
          priceDisplay.textContent = priceText.textContent;
        }

        // Update serving info
        if (servingInfoContainer) {
          const variantTitle = this.dataset.variantTitle || '';
          const servingSize = getServingSize(variantTitle);

          if (servingSize) {
            servingInfoContainer.innerHTML = '<p class="serving-info__text">' + servingSize + '</p>';
          } else {
            servingInfoContainer.innerHTML = '';
          }
        }
      }
    });
  });
});
